export const CNC_CODE_ACTIONS = {
    CNC_INVALID_ORDER_ID:               { action: 'redirect_home' },
    CNC_INVALID_ORDER_STATUS:           { action: 'redirect_tracking' },
    CNC_ORIGINAL_NOT_CUBBO_BILLED:      { action: 'message', translationKey: 'clickAndCollect.error_not_cubbo_billed' },
    CNC_ORIGINAL_NOT_NATIONAL_SHIPPING: { action: 'message', translationKey: 'clickAndCollect.error_not_national_shipping' },
    CNC_PRICE_EXCEEDS_ORIGINAL:         { action: 'message', translationKey: 'clickAndCollect.error_price_exceeds' },
    CNC_RATE_CARD_UNAVAILABLE:          { action: 'message', translationKey: 'clickAndCollect.error_rate_card_unavailable' },
}

export const resolveCncErrorCode = (code) => CNC_CODE_ACTIONS[code] || null
